import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { IconShare } from '../../components';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  const handleShare = async () => {
    const shareData = {
      title: listing.attributes.title,
      text: listing.attributes.title,
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        // Fallback: copy to clipboard
        await navigator.clipboard.writeText(window.location.href);
        alert('Link copied to clipboard!');
      }
    } catch (err) {
      // User cancelled or error occurred
      console.log('Share failed:', err);
    }
  };

  return (
    <section className={css.productGallery} data-testid="carousel">
      <div className={css.galleryContainer}>
        <ListingImageGallery
          images={images}
          imageVariants={imageVariants}
          thumbnailVariants={thumbnailVariants}
        />
        <button className={css.shareButtonGallery} onClick={handleShare}>
          <IconShare />
          <span className={css.shareButtonText}>
            <FormattedMessage id="ListingPage.shareButton" />
          </span>
        </button>
      </div>
    </section>
  );
};

export default SectionGallery;
